import { AVI1O } from "../../data/OSSD/Grade9/AVI1O";
import GradeCourseTemplate from "../../pageTemplate/GradeCourseTemplate";


export default function AVI1OPage() {
    return (
        <div>
            <GradeCourseTemplate data={AVI1O} />
        </div>
    )
}